import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="container-site py-24 text-center" data-testid="not-found-page">
      <h1 className="text-4xl sm:text-5xl font-semibold">Page not found</h1>
      <p className="lead mt-4">The page you are looking for may have moved.</p>
      <Link to="/" className="btn-pill btn-primary mt-8" data-testid="not-found-home-link">Return home</Link>
    </section>
  );
}
